/* eslint-disable */

import React from "react";
import Loading from "dan-components/Loading";
import loadable from "../utils/loadable";

// Landing Page
export const HomePage = loadable(() => import("./LandingPage/HomePage"), {
  fallback: <Loading />,
});
export const SliderPage = loadable(() => import("./LandingPage/SliderPage"), {
  fallback: <Loading />,
});

// Layouts
export const AppLayout = loadable(() => import("./Layouts/AppLayout"), {
  fallback: <Loading />,
});
export const Responsive = loadable(() => import("./Layouts/Responsive"), {
  fallback: <Loading />,
});
export const Grid = loadable(() => import("./Layouts/Grid"), {
  fallback: <Loading />,
});

export const TablePlayground = loadable(
  () => import("./Tables/TablePlayground"),
  {
    fallback: <Loading />,
  }
);

// Forms

export const DateTimePicker = loadable(() => import("./Forms/DateTimePicker"), {
  fallback: <Loading />,
});
export const CheckboxRadio = loadable(() => import("./Forms/CheckboxRadio"), {
  fallback: <Loading />,
});
export const Switches = loadable(() => import("./Forms/Switches"), {
  fallback: <Loading />,
});
export const Selectbox = loadable(() => import("./Forms/Selectbox"), {
  fallback: <Loading />,
});

export const SliderRange = loadable(() => import("./Forms/SliderRange"), {
  fallback: <Loading />,
});
export const Buttons = loadable(() => import("./Forms/Buttons"), {
  fallback: <Loading />,
});
export const ToggleButton = loadable(() => import("./Forms/ToggleButton"), {
  fallback: <Loading />,
});
export const DialButton = loadable(() => import("./Forms/DialButton"), {
  fallback: <Loading />,
});
export const Textbox = loadable(() => import("./Forms/Textbox"), {
  fallback: <Loading />,
});
export const Autocomplete = loadable(() => import("./Forms/Autocomplete"), {
  fallback: <Loading />,
});

export const Upload = loadable(() => import("./Forms/Upload"), {
  fallback: <Loading />,
});

// UI Components

export const Avatars = loadable(() => import("./UiElements/Avatars"), {
  fallback: <Loading />,
});
export const Accordion = loadable(() => import("./UiElements/Accordion"), {
  fallback: <Loading />,
});
export const List = loadable(() => import("./UiElements/List"), {
  fallback: <Loading />,
});
export const PopoverTooltip = loadable(
  () => import("./UiElements/PopoverTooltip"),
  {
    fallback: <Loading />,
  }
);
export const Snackbar = loadable(() => import("./UiElements/Snackbar"), {
  fallback: <Loading />,
});

export const Tabs = loadable(() => import("./UiElements/Tabs"), {
  fallback: <Loading />,
});

export const ImageGrid = loadable(() => import("./UiElements/ImageGrid"), {
  fallback: <Loading />,
});
export const Progress = loadable(() => import("./UiElements/Progress"), {
  fallback: <Loading />,
});
export const DialogModal = loadable(() => import("./UiElements/DialogModal"), {
  fallback: <Loading />,
});
export const Steppers = loadable(() => import("./UiElements/Steppers"), {
  fallback: <Loading />,
});
export const DrawerMenu = loadable(() => import("./UiElements/DrawerMenu"), {
  fallback: <Loading />,
});
export const Paginations = loadable(() => import("./UiElements/Paginations"), {
  fallback: <Loading />,
});
export const Breadcrumbs = loadable(() => import("./UiElements/Breadcrumbs"), {
  fallback: <Loading />,
});
export const Icons = loadable(() => import("./UiElements/Icons"), {
  fallback: <Loading />,
});
export const IonIcons = loadable(() => import("./UiElements/IonIcons"), {
  fallback: <Loading />,
});
export const SliderCarousel = loadable(
  () => import("./UiElements/SliderCarousel"),
  {
    fallback: <Loading />,
  }
);
export const Tags = loadable(() => import("./UiElements/Tags"), {
  fallback: <Loading />,
});
export const Dividers = loadable(() => import("./UiElements/Dividers"), {
  fallback: <Loading />,
});

// Pages
export const Login = loadable(() => import("./Pages/Users/Login"), {
  fallback: <Loading />,
});

export const Register = loadable(() => import("./Pages/Users/Register"), {
  fallback: <Loading />,
});

export const Profile = loadable(() => import("./Pages/UserProfile"), {
  fallback: <Loading />,
});
// export const Timeline = loadable(() => import("./SampleApps/Timeline"), {
//   fallback: <Loading />,
// });
export const BlankPage = loadable(() => import("./Pages/BlankPage"), {
  fallback: <Loading />,
});

export const Photos = loadable(() => import("./Pages/Photos"), {
  fallback: <Loading />,
});

// Other
export const NotFound = loadable(() => import("./NotFound/NotFound"), {
  fallback: <Loading />,
});
export const NotFoundDedicated = loadable(
  () => import("./Pages/Standalone/NotFoundDedicated"),
  {
    fallback: <Loading />,
  }
);
export const Error = loadable(() => import("./Pages/Error"), {
  fallback: <Loading />,
});
export const Maintenance = loadable(() => import("./Pages/Maintenance"), {
  fallback: <Loading />,
});
export const Parent = loadable(() => import("./Parent"), {
  fallback: <Loading />,
});
export const Settings = loadable(() => import("./Pages/Settings"), {
  fallback: <Loading />,
});

export const UserProfile = loadable(() => import("./User/UserProfile"), {
  fallback: <Loading />,
});
export const Activity = loadable(
  () => import("/app/containers/Templates/ICcoordinator/Activity/Activity"),
  {
    fallback: <Loading />,
  }
);
export const IndexActivity = loadable(
  () => import("/app/containers/Templates/Admin/Activities/IndexActivity"),
  {
    fallback: <Loading />,
  }
);

// Rishabh Code

export const CreateConference = loadable(
  () => import("./Templates/Pages/CreateConference"),
  {
    fallback: <Loading />,
  }
);

export const CreateTrack = loadable(
  () => import("./Templates/Pages/CreateTrack"),
  {
    fallback: <Loading />,
  }
);

export const ViewConferences = loadable(
  () => import("./Templates/Pages/ViewConferences"),
  {
    fallback: <Loading />,
  }
);
export const ViewConferencesUser = loadable(
  () => import("./Templates/Pages/UserPages/ViewConferencesUser"),
  {
    fallback: <Loading />,
  }
);

export const ConferenceDetail = loadable(
  () => import("./Templates/Pages/ConferenceDetail"),
  {
    fallback: <Loading />,
  }
);

export const GeneralSettingsConfOrganiser = loadable(
  () => import("./Templates/Pages/GeneralSettingsConfOrganiser"),
  {
    fallback: <Loading />,
  }
);

export const AdditionSettingsOrganiser = loadable(
  () => import("./Templates/Pages/AdditionSettingsOrganiser"),
  {
    fallback: <Loading />,
  }
);

export const ConferenceSubmissionUser = loadable(
  () => import("./Templates/Pages/UserPages/ConferenceSubmissionUser"),
  {
    fallback: <Loading />,
  }
);

export const ConferenceSettingsModal = loadable(
  () => import("./Templates/Components/Modal/ConferenceSettingsModal"),
  {
    fallback: <Loading />,
  }
);

export const AssignReviewerModal = loadable(
  () => import("./Templates/Components/Modal/AssignReviewerModal"),
  {
    fallback: <Loading />,
  }
);

// export const OrganiserDashboard = loadable(
//   () => import("./Dashboard/OrganiserDashboard"),
//   {
//     fallback: <Loading />,
//   }
// );

// export const ReviewerDashboard = loadable(
//   () => import("./Dashboard/ReviewerDashboard"),
//   {
//     fallback: <Loading />,
//   }
// );

export const UserDashboard = loadable(
  () => import("./Dashboard/UserDashboard"),
  {
    fallback: <Loading />,
  }
);

// export const CreateTrack3 = loadable(
//   () => import("./Templates/Pages/CreateTrack2"),
//   {
//     fallback: <Loading />,
//   }
// );

// user Submissions that he submitted
export const CertificateIndex = loadable(
  () => import("/app/components/Widget/MyCertificates/CertificateIndex"),
  {
    fallback: <Loading />,
  }
);
// export const Labindex = loadable(
//   () => import("/app/components/Widget/Mylabs/Labindex"),
//   {
//     fallback: <Loading />,
//   }
// );

export const ContributionIndex = loadable(
  () => import("/app/components/Widget/Contributions/ContributionIndex"),
  {
    fallback: <Loading />,
  }
);

export const ViewAllSubmissionsUser = loadable(
  () => import("./Templates/Pages/UserPages/ViewAllSubmissionsUser"),
  {
    fallback: <Loading />,
  }
);

export const ReviewSubmissionsUser = loadable(
  () => import("./Templates/Pages/UserPages/ReviewSubmissionsUser"),
  {
    fallback: <Loading />,
  }
);

export const ViewSubmissionDetailsReviewer = loadable(
  () => import("./Templates/Pages/UserPages/ViewSubmissionDetailsReviewer"),
  {
    fallback: <Loading />,
  }
);

export const ReviewSubmissionsConf = loadable(
  () => import("./Templates/Pages/UserPages/ReviewSubmissionConf"),
  {
    fallback: <Loading />,
  }
);

export const ViewOrganiserReviewConference = loadable(
  () => import("./Templates/Pages/ViewReviewConferences"),
  {
    fallback: <Loading />,
  }
);

export const ReviewSubmissionsOrganiser = loadable(
  () => import("./Templates/Pages/ReviewSubmissionsOrganiser"),
  {
    fallback: <Loading />,
  }
);

export const ViewSubmissionDetailsOrganiser = loadable(
  () => import("./Templates/Pages/ViewSubmissionDetailsOrganiser"),
  {
    fallback: <Loading />,
  }
);

export const AssignReviewers = loadable(
  () => import("./Templates/Components/AssignReviewers/AssignReviewers"),
  {
    fallback: <Loading />,
  }
);

export const CreateCriteria = loadable(
  () => import("./Templates/Components/CreateCriteria/CreateCriteria"),
  {
    fallback: <Loading />,
  }
);

export const CreateTimeSlots = loadable(
  () => import("./Templates/Components/CreateTimeSlots/CreateTimeSlots"),
  {
    fallback: <Loading />,
  }
);

export const FeatureNavPageUser = loadable(
  () => import("./Templates/Pages/UserPages/FeatureNavPageUser"),
  {
    fallback: <Loading />,
  }
);
export const FeatureNavPageOrganiser = loadable(
  () => import("./Templates/Pages/FeatureNavPageOrganiser"),
  {
    fallback: <Loading />,
  }
);
export const submissionReviewFormOrganiser = loadable(
  () =>
    import(
      "./Templates/Components/SubmissionReviewFormOrganiser/SubmissionReviewFormOrganiser"
    ),
  {
    fallback: <Loading />,
  }
);

export const ViewConferenceResults = loadable(
  () => import("./Templates/Pages/ViewConferenceResults"),
  {
    fallback: <Loading />,
  }
);

export const MailSettingPage = loadable(
  () => import("./Templates/Pages/MailSettingPage"),
  {
    fallback: <Loading />,
  }
);

export const ConferenceHomepage = loadable(
  () => import("./Templates/Components/Home/Homepage"),
  {
    fallback: <Loading />,
  }
);

export const ConferenceHomeDetailsPage = loadable(
  () => import("./Templates/Components/HomeDetails/DetailsPage"),
  {
    fallback: <Loading />,
  }
);

export const GenerateCertificates = loadable(
  () => import("./Templates/Pages/GenerateCertificates"),
  {
    fallback: <Loading />,
  }
);

export const CertificatesUser = loadable(
  () => import("./Templates/Pages/UserPages/CertificatesUser"),
  {
    fallback: <Loading />,
  }
);
// User Courses

export const AllCoursesCategories = loadable(
  () => import("./Templates/User/Courses/AllCoursesCategories"),
  {
    fallback: <Loading />,
  }
);

export const CategoryWiseAllCourses = loadable(
  () => import("./Templates/User/Courses/CategoryWiseAllCourses"),
  {
    fallback: <Loading />,
  }
);
export const NewsAndArticles = loadable(
  () => import("./Templates/Admin/NewsAndArticles/NewsAndArticles"),
  {
    fallback: <Loading />,
  }
);

export const AssignMultipleUsersByEmail = loadable(
  () =>
    import(
      "./Templates/Components/AssignMultipleUsersByEmail/AssignMultipleUsersByEmail"
    ),
  {
    fallback: <Loading />,
  }
);
export const ViewAllNewsAndArticlesHome = loadable(
  () => import("./Templates/Admin/NewsAndArticles/ViewAllNewsAndArticlesHome"),
  {
    fallback: <Loading />,
  }
);

export const IndexEventTracking = loadable(
  () => import("./Templates/EventTracking/Index"),
  {
    fallback: <Loading />,
  }
);
export const IndexAchievemnets = loadable(
  () => import("./Templates/Admin/Achievements/AchievementsIndex"),
  {
    fallback: <Loading />,
  }
);
